import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/shared/services/dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-user-setting',
  templateUrl: './user-setting.component.html',
  styleUrls: ['./user-setting.component.scss']
})
export class UserSettingComponent implements OnInit {

  public action: any = '';
  public accounts: any = [];
  public order_menu_list: any = [];
  public location: any = { cities: { dropdownList: [], selectedItems: [] }, states: [] };
  public locationDropdownSettings: IDropdownSettings;
  public nmDropdownSettings: IDropdownSettings;

  public setting: any = { status: '', account: '', meta_key: 'config' }

  public meta_value: any = { allow_disk_space: '', peak: { start: '', end: '' }, location: { city: '', state: '', country: 'pk' }, nm: { ke: [], pv: [], gs: [] }, btn_password: '', level_unit: '', flow_unit: '', flow_rate: '' }
  public mv_opt: any = { allow_disk_space: { value: '', checkbox: false, disabled: 'true' }, peak: { start: '', end: '', checkbox: false, disabled: 'true' }, location: { city: '', state: '', country: 'Pakistan', checkbox: false, disabled: 'true' }, nm: { ke: { value: [], dropdownList: [], checkbox: false, disabled: 'true' }, pv: { value: [], dropdownList: [], checkbox: false, disabled: 'true' }, gs: { value: [], dropdownList: [], checkbox: false, disabled: 'true' }, checkbox: false, display: 'd-none' }, btn_password: { value: '', checkbox: false, disabled: 'true' }, level_unit: { value: '', checkbox: false, disabled: 'true' }, flow_unit: { value: '', checkbox: false, disabled: 'true' }, flow_rate: { value: '', checkbox: false, disabled: 'true' } }

  public dashboard_setting: any = { default_menu: "", parent_menu_1: { value: "Dashboard", chlid_menu_1: { value: "Single", status: false }, chlid_menu_2: { value: "Collective", status: false }, chlid_menu_3: { value: "Comparative", status: false }, status: false }, parent_menu_2: { value: "Analytics", chlid_menu_1: { value: "Energy Trend", sub_chlid_1: { value: "Single", status: false }, sub_chlid_2: { value: "Collective", status: false }, sub_chlid_3: { value: "Comparative", status: false }, status: false }, chlid_menu_2: { value: "Power Trend", status: false }, chlid_menu_3: { value: "Heat Map", status: false }, chlid_menu_4: { value: "Share Consumption", status: false }, chlid_menu_5: { value: "Min Max", status: false }, status: false }, parent_menu_3: { value: "Pv Net Metering", status: false }, parent_menu_4: { value: "Pv String Monitoring", status: false }, parent_menu_5: { value: "Charts", status: false }, parent_menu_6: { value: "Status", status: false }, parent_menu_7: { value: "Alarm Logs", status: false }, parent_menu_8: { value: "Favorite", status: false }, parent_menu_9: { value: "Billing Summary", status: false }, parent_menu_10: { value: "Settings", status: false }, parent_menu_11: { value: "Button Management", status: false }, parent_menu_13: { value: "Flow Tracking", status: true } }
  public tab_setting: any = { allow_tab: { dashboard: { single: { trends: false, graph: false, table: false, overview: false }, collective: { graph: false, table: false }, comparative: { graph: false, table: false } }, analytics: { energy_trend: { single: { graph: false, consumer_billing: false, payment_summary: false } } }, pv_string_monitoring: { graph: false, table: false, comparative: false, comparative_table: false, pv_generation_report: false }, pv_net_metering: { graph: false, billing_and_income_table: false, saving_table: false, pv_yeild_energy: false, consumption: false, energy_balance: false, plant_performance_by_table: false, plant_performance_by_graph: false, basis_of_plant_performance_calculation: false }, status: { device_status: false, memory_status: false, internet_quality: false }, settings: { alarm: false, cost: false, counter_correction: false } } }
  public kpi_setting: any = { dashboard_powertrend_kpis: { kpi_1: { name: "Voltage", status: false }, kpi_2: { name: "Current", status: false }, kpi_3: { name: "Kw (now)", status: false }, kpi_4: { name: "Frequency", status: false }, kpi_5: { name: "Power Factor", status: false } }, dashboard_flowmeter_kpis: { kpi_1: { name: "Inst. Flow Rate (us.gpm)", status: false }, kpi_2: { name: "Today's Flow (us.gal)", status: false }, kpi_3: { name: "Monthly Flow (us.gal)", status: false }, kpi_4: { name: "Yearly Flow (us.gal)", status: false }, kpi_5: { name: "Flow Counter (us.gal)", status: false } }, dashboard_sensor_kpis: { kpi_1: { name: "Temperature", status: false }, kpi_2: { name: "Humidity", status: false }, kpi_3: { name: "Pressure", status: false }, kpi_4: { name: "CO2", status: false }, kpi_5: { name: "Live Weather", status: false } }, energy_trend_kpis: { kpi_1: { name: "Kw (now)", status: false }, kpi_2: { name: "Today's Energy", status: false }, kpi_3: { name: "Monthly Energy", status: false }, kpi_4: { name: "Yearly Energy", status: false }, kpi_5: { name: "Energy Counter", status: false } }, pv_string_monitoring_kpi: { kpi_1: { name: "Voltage", status: false }, kpi_2: { name: "Current", status: false }, kpi_3: { name: "Kw (now)", status: false }, kpi_4: { name: "Today's Energy", status: false }, kpi_5: { name: "Weather", status: false } }, pv_net_metering_kpis: { kpi_1: { name: "Total Kwh Today", status: false }, kpi_2: { name: "PV-Yeild Energy", status: false }, kpi_3: { name: "PV-Self Use", status: false }, kpi_4: { name: "Export To Gird", status: false }, kpi_5: { name: "Import From Gird", status: false }, kpi_6: { name: "Genset", status: false } } }
  public chart_setting: any = { dashboard: { single: { graph: { chart_1: { header: "AVG. LINE VOLTAGE VL-L (VOLTS)", title: "Voltage (Volts)", unit: "Volt", status: false }, chart_2: { header: "AVG. 3 PHASE CURRENT (AMPS)", title: "Current (Amps)", unit: "Amp", status: false }, chart_3: { header: "TOTAL ACTIVE POWER (KW)", title: "Power (KW)", unit: "Kw", status: false }, chart_4: { header: "POWER FACTOR 3 PHASE (AVG)", title: "Power Factor", unit: "Power Factor", status: false } } } }, pv_string_monitoring: { graph: { chart_1: { header: "Power", title: "PV Power (KWh)", unit: "Power", status: false }, chart_2: { header: "Current", title: "PV Current", unit: "Current", status: false }, chart_3: { header: "Energy", title: "PV Energy", unit: "Energy", status: false }, chart_4: { header: "Voltage", title: "PV Voltage", unit: "Voltage", status: false } } }, pv_net_metering: { graph: { chart_1: { header: "Power Trend", title: "Power (KWh)", unit: { unit_1: "PV POWER", unit_2: "UTILITY POWER", unit_3: "LOAD POWER" }, status: false }, chart_2: { header: "Current State", status: false }, chart_3: { header: "Pv-Yeild Energy", status: false }, chart_4: { header: "Weather", status: false } } } }

  public cost_by_month_value: any = { "per_kwh_unit_rate": 0, "selling_rate": 0, "service_charges": 0, "misc_charges": 0, "late_charges": 0, "genset_unit_rate_rs": 0, "modified_on": "" }
  public cost_by_month: any = { "january": { [new Date().getFullYear()]: { "per_kwh_unit_rate(rs)": 0, "selling_rate(rs)": 0, "service_charges": 0, "misc_charges": 0, "late_charges": 0, "genset_unit_rate_rs": 0, "modified_on": "" } }, "february": { [new Date().getFullYear()]: { "per_kwh_unit_rate(rs)": 0, "selling_rate(rs)": 0, "service_charges": 0, "misc_charges": 0, "late_charges": 0, "genset_unit_rate_rs": 0, "modified_on": "" } }, "march": { [new Date().getFullYear()]: { "per_kwh_unit_rate(rs)": 0, "selling_rate(rs)": 0, "service_charges": 0, "misc_charges": 0, "late_charges": 0, "genset_unit_rate_rs": 0, "modified_on": "" } }, "april": { [new Date().getFullYear()]: { "per_kwh_unit_rate(rs)": 0, "selling_rate(rs)": 0, "service_charges": 0, "misc_charges": 0, "late_charges": 0, "genset_unit_rate_rs": 0, "modified_on": "" } }, "may": { [new Date().getFullYear()]: { "per_kwh_unit_rate(rs)": 0, "selling_rate(rs)": 0, "service_charges": 0, "misc_charges": 0, "late_charges": 0, "genset_unit_rate_rs": 0, "modified_on": "" } }, "june": { [new Date().getFullYear()]: { "per_kwh_unit_rate(rs)": 0, "selling_rate(rs)": 0, "service_charges": 0, "misc_charges": 0, "late_charges": 0, "genset_unit_rate_rs": 0, "modified_on": "" } }, "july": { [new Date().getFullYear()]: { "per_kwh_unit_rate(rs)": 0, "selling_rate(rs)": 0, "service_charges": 0, "misc_charges": 0, "late_charges": 0, "genset_unit_rate_rs": 0, "modified_on": "" } }, "august": { [new Date().getFullYear()]: { "per_kwh_unit_rate(rs)": 0, "selling_rate(rs)": 0, "service_charges": 0, "misc_charges": 0, "late_charges": 0, "genset_unit_rate_rs": 0, "modified_on": "" } }, "september": { [new Date().getFullYear()]: { "per_kwh_unit_rate(rs)": 0, "selling_rate(rs)": 0, "service_charges": 0, "misc_charges": 0, "late_charges": 0, "genset_unit_rate_rs": 0, "modified_on": "" } }, "october": { [new Date().getFullYear()]: { "per_kwh_unit_rate(rs)": 0, "selling_rate(rs)": 0, "service_charges": 0, "misc_charges": 0, "late_charges": 0, "genset_unit_rate_rs": 0, "modified_on": "" } }, "november": { [new Date().getFullYear()]: { "per_kwh_unit_rate(rs)": 0, "selling_rate(rs)": 0, "service_charges": 0, "misc_charges": 0, "late_charges": 0, "genset_unit_rate_rs": 0, "modified_on": "" } }, "december": { [new Date().getFullYear()]: { "per_kwh_unit_rate(rs)": 0, "selling_rate(rs)": 0, "service_charges": 0, "misc_charges": 0, "late_charges": 0, "genset_unit_rate_rs": 0, "modified_on": "" } } }
  public solar_performance_parameters: any = { installed_capicity: 0, predicted_generation: 0, inverter_make: "", panel_make: "", location: "", solar_insolation: 0, average_sun_perday: 0, carbon_factor: 0 }
  public solar_performance_parameters_status: boolean = false

  constructor(private dashboardService: DashboardService, private toastr: ToastrService, private dataShared: DataSharedService) { }

  ngOnInit(): void {

    this.order_menu_list = Object.keys(this.dataShared.order_menu_list);
    this.getCities();
    this.getStates();
    this.getAccounts();

    if (!this.dashboard_setting.parent_menu_13) {
      this.dashboard_setting.parent_menu_13 = { value: 'Flow Tracking', status: true };
    }
  }

  defaultSettings(type) {

    if (type == 'dashboard') {

      this.dashboard_setting.default_menu = "/dashboard/single"

      // status
      // parent  
      this.dashboard_setting.parent_menu_1.status = true;
      this.dashboard_setting.parent_menu_2.status = true;
      this.dashboard_setting.parent_menu_3.status = false;
      this.dashboard_setting.parent_menu_4.status = false;
      this.dashboard_setting.parent_menu_5.status = false;
      this.dashboard_setting.parent_menu_6.status = true;
      this.dashboard_setting.parent_menu_7.status = false;
      this.dashboard_setting.parent_menu_8.status = true;
      this.dashboard_setting.parent_menu_9.status = false;
      this.dashboard_setting.parent_menu_10.status = false;
      this.dashboard_setting.parent_menu_11.status = false;
      this.dashboard_setting.parent_menu_13.status = true;

      // chlid 
      this.dashboard_setting.parent_menu_1.chlid_menu_1.status = true;
      this.dashboard_setting.parent_menu_1.chlid_menu_2.status = false;
      this.dashboard_setting.parent_menu_1.chlid_menu_3.status = false;
      this.dashboard_setting.parent_menu_2.chlid_menu_1.status = true;
      this.dashboard_setting.parent_menu_2.chlid_menu_2.status = true;
      this.dashboard_setting.parent_menu_2.chlid_menu_3.status = false;
      this.dashboard_setting.parent_menu_2.chlid_menu_4.status = true;
      this.dashboard_setting.parent_menu_2.chlid_menu_5.status = true;

      // sub child
      this.dashboard_setting.parent_menu_2.chlid_menu_1.sub_chlid_1.status = true;
      this.dashboard_setting.parent_menu_2.chlid_menu_1.sub_chlid_2.status = true;
      this.dashboard_setting.parent_menu_2.chlid_menu_1.sub_chlid_3.status = true;

      
      // value 
      // parent  
      this.dashboard_setting.parent_menu_1.value = "Dashboard";
      this.dashboard_setting.parent_menu_2.value = "Analytics";
      this.dashboard_setting.parent_menu_3.value = "Pv Net Metering";
      this.dashboard_setting.parent_menu_4.value = "Pv String Monitoring";
      this.dashboard_setting.parent_menu_5.value = "Charts";
      this.dashboard_setting.parent_menu_6.value = "Status";
      this.dashboard_setting.parent_menu_7.value = "Alarm Logs";
      this.dashboard_setting.parent_menu_8.value = "Favorite";
      this.dashboard_setting.parent_menu_9.value = "Billing Summary";
      this.dashboard_setting.parent_menu_10.value = "Settings";
      this.dashboard_setting.parent_menu_11.value = "Button Management";
      this.dashboard_setting.parent_menu_13.value = "Flow Tracking";
      
      // chlid 
      this.dashboard_setting.parent_menu_1.chlid_menu_1.value = "Single";
      this.dashboard_setting.parent_menu_1.chlid_menu_2.value = "Collective";
      this.dashboard_setting.parent_menu_1.chlid_menu_3.value = "Comparative";
      this.dashboard_setting.parent_menu_2.chlid_menu_1.value = "Energy Trend";
      this.dashboard_setting.parent_menu_2.chlid_menu_2.value = "Power Trend";
      this.dashboard_setting.parent_menu_2.chlid_menu_3.value = "Heat Map";
      this.dashboard_setting.parent_menu_2.chlid_menu_4.value = "Share Consumption";
      this.dashboard_setting.parent_menu_2.chlid_menu_5.value = "Min Max";
      
      // sub child
      this.dashboard_setting.parent_menu_2.chlid_menu_1.sub_chlid_1.value = "Single";
      this.dashboard_setting.parent_menu_2.chlid_menu_1.sub_chlid_2.value = "Collective";
      this.dashboard_setting.parent_menu_2.chlid_menu_1.sub_chlid_3.value = "Comparative";


    }

    if (type == 'tab') {

      // dashboard
      this.tab_setting.allow_tab.dashboard.single.trends = (this.dashboard_setting.parent_menu_1.chlid_menu_1.status) ? true : false;
      this.tab_setting.allow_tab.dashboard.single.table = (this.dashboard_setting.parent_menu_1.chlid_menu_1.status) ? true : false;
      this.tab_setting.allow_tab.dashboard.collective.graph = (this.dashboard_setting.parent_menu_1.chlid_menu_2.status) ? true : false;
      this.tab_setting.allow_tab.dashboard.collective.table = (this.dashboard_setting.parent_menu_1.chlid_menu_2.status) ? true : false;
      this.tab_setting.allow_tab.dashboard.comparative.graph = (this.dashboard_setting.parent_menu_1.chlid_menu_3.status) ? true : false;
      this.tab_setting.allow_tab.dashboard.comparative.table = (this.dashboard_setting.parent_menu_1.chlid_menu_3.status) ? true : false;

      // analytics 
      this.tab_setting.allow_tab.analytics.energy_trend.graph = (this.dashboard_setting.parent_menu_2.chlid_menu_1.sub_chlid_1.status) ? true : false;

      // pv_string_monitoring 
      this.tab_setting.allow_tab.pv_string_monitoring.graph = (this.dashboard_setting.parent_menu_4.status) ? true : false;
      this.tab_setting.allow_tab.pv_string_monitoring.table = (this.dashboard_setting.parent_menu_4.status) ? true : false;
      this.tab_setting.allow_tab.pv_string_monitoring.comparative = (this.dashboard_setting.parent_menu_4.status) ? true : false;
      this.tab_setting.allow_tab.pv_string_monitoring.comparative_table = (this.dashboard_setting.parent_menu_4.status) ? true : false;
      this.tab_setting.allow_tab.pv_string_monitoring.pv_generation_report = (this.dashboard_setting.parent_menu_4.status) ? true : false;

      // pv_net_metering
      this.tab_setting.allow_tab.pv_net_metering.graph = (this.dashboard_setting.parent_menu_3.status) ? true : false;
      this.tab_setting.allow_tab.pv_net_metering.billing_and_income_table = (this.dashboard_setting.parent_menu_3.status) ? true : false;
      this.tab_setting.allow_tab.pv_net_metering.saving_table = (this.dashboard_setting.parent_menu_3.status) ? true : false;
      this.tab_setting.allow_tab.pv_net_metering.pv_yeild_energy = (this.dashboard_setting.parent_menu_3.status) ? true : false;
      this.tab_setting.allow_tab.pv_net_metering.consumption = (this.dashboard_setting.parent_menu_3.status) ? true : false;
      this.tab_setting.allow_tab.pv_net_metering.energy_balance = (this.dashboard_setting.parent_menu_3.status) ? true : false;

      // status 
      this.tab_setting.allow_tab.status.device_status = (this.dashboard_setting.parent_menu_6.status) ? true : false;
      this.tab_setting.allow_tab.status.memory_status = (this.dashboard_setting.parent_menu_6.status) ? true : false;
      this.tab_setting.allow_tab.status.internet_quality = (this.dashboard_setting.parent_menu_6.status) ? true : false;

      // settings
      this.tab_setting.allow_tab.settings.cost = (this.dashboard_setting.parent_menu_10.status) ? true : false;
    }

    if (type == 'kpi') {

      // status 
      // dashboard_powertrend_kpis
      this.kpi_setting.dashboard_powertrend_kpis.kpi_1.status = true;
      this.kpi_setting.dashboard_powertrend_kpis.kpi_2.status = true;
      this.kpi_setting.dashboard_powertrend_kpis.kpi_3.status = true;
      this.kpi_setting.dashboard_powertrend_kpis.kpi_4.status = true;
      this.kpi_setting.dashboard_powertrend_kpis.kpi_5.status = true;

      // dashboard_flowmeter_kpis
      this.kpi_setting.dashboard_flowmeter_kpis.kpi_1.status = true;
      this.kpi_setting.dashboard_flowmeter_kpis.kpi_2.status = true;
      this.kpi_setting.dashboard_flowmeter_kpis.kpi_3.status = true;
      this.kpi_setting.dashboard_flowmeter_kpis.kpi_4.status = true;
      this.kpi_setting.dashboard_flowmeter_kpis.kpi_5.status = true;

      // dashboard_sensor_kpis
      this.kpi_setting.dashboard_sensor_kpis.kpi_1.status = true;
      this.kpi_setting.dashboard_sensor_kpis.kpi_2.status = true;
      this.kpi_setting.dashboard_sensor_kpis.kpi_3.status = true;
      this.kpi_setting.dashboard_sensor_kpis.kpi_4.status = true;
      this.kpi_setting.dashboard_sensor_kpis.kpi_5.status = true;

      // energy_trend_kpis 
      this.kpi_setting.energy_trend_kpis.kpi_1.status = true;
      this.kpi_setting.energy_trend_kpis.kpi_2.status = true;
      this.kpi_setting.energy_trend_kpis.kpi_3.status = true;
      this.kpi_setting.energy_trend_kpis.kpi_4.status = true;
      this.kpi_setting.energy_trend_kpis.kpi_5.status = true;

      // pv_string_monitoring_kpi 
      this.kpi_setting.pv_string_monitoring_kpi.kpi_1.status = true;
      this.kpi_setting.pv_string_monitoring_kpi.kpi_2.status = true;
      this.kpi_setting.pv_string_monitoring_kpi.kpi_3.status = true;
      this.kpi_setting.pv_string_monitoring_kpi.kpi_4.status = true;
      this.kpi_setting.pv_string_monitoring_kpi.kpi_5.status = true;

      // pv_net_metering_kpis 
      this.kpi_setting.pv_net_metering_kpis.kpi_1.status = true;
      this.kpi_setting.pv_net_metering_kpis.kpi_2.status = true;
      this.kpi_setting.pv_net_metering_kpis.kpi_3.status = true;
      this.kpi_setting.pv_net_metering_kpis.kpi_4.status = true;
      this.kpi_setting.pv_net_metering_kpis.kpi_5.status = true;
      this.kpi_setting.pv_net_metering_kpis.kpi_6.status = true;

      // name
      // dashboard_powertrend_kpis
      this.kpi_setting.dashboard_powertrend_kpis.kpi_1.name = "Voltage";
      this.kpi_setting.dashboard_powertrend_kpis.kpi_2.name = "Current";
      this.kpi_setting.dashboard_powertrend_kpis.kpi_3.name = "Kw (now)";
      this.kpi_setting.dashboard_powertrend_kpis.kpi_4.name = "Frequency";
      this.kpi_setting.dashboard_powertrend_kpis.kpi_5.name = "Power Factor";

      // dashboard_flowmeter_kpis
      this.kpi_setting.dashboard_flowmeter_kpis.kpi_1.name = "Inst. Flow Rate (us.gpm)";
      this.kpi_setting.dashboard_flowmeter_kpis.kpi_2.name = "Today's Flow (us.gal)";
      this.kpi_setting.dashboard_flowmeter_kpis.kpi_3.name = "Monthly Flow (us.gal)";
      this.kpi_setting.dashboard_flowmeter_kpis.kpi_4.name = "Yearly Flow (us.gal)";
      this.kpi_setting.dashboard_flowmeter_kpis.kpi_5.name = "Flow Counter (us.gal)";

      // dashboard_sensor_kpis
      this.kpi_setting.dashboard_sensor_kpis.kpi_1.name = "Temperature";
      this.kpi_setting.dashboard_sensor_kpis.kpi_2.name = "Humidity";
      this.kpi_setting.dashboard_sensor_kpis.kpi_3.name = "Pressure";
      this.kpi_setting.dashboard_sensor_kpis.kpi_4.name = "CO2";
      this.kpi_setting.dashboard_sensor_kpis.kpi_5.name = "Live Weather";

      // energy_trend_kpis 
      this.kpi_setting.energy_trend_kpis.kpi_1.name = "Kw (now)";
      this.kpi_setting.energy_trend_kpis.kpi_2.name = "Today's Energy";
      this.kpi_setting.energy_trend_kpis.kpi_3.name = "Monthly Energy";
      this.kpi_setting.energy_trend_kpis.kpi_4.name = "Yearly Energy";
      this.kpi_setting.energy_trend_kpis.kpi_5.name = "Energy Counter";

      // pv_string_monitoring_kpi 
      this.kpi_setting.pv_string_monitoring_kpi.kpi_1.name = "Voltage";
      this.kpi_setting.pv_string_monitoring_kpi.kpi_2.name = "Current";
      this.kpi_setting.pv_string_monitoring_kpi.kpi_3.name = "Kw (now)";
      this.kpi_setting.pv_string_monitoring_kpi.kpi_4.name = "Today's Energy";
      this.kpi_setting.pv_string_monitoring_kpi.kpi_5.name = "Weather";

      // pv_net_metering_kpis 
      this.kpi_setting.pv_net_metering_kpis.kpi_1.name = "Total Kwh Today";
      this.kpi_setting.pv_net_metering_kpis.kpi_2.name = "PV-Yeild Energy";
      this.kpi_setting.pv_net_metering_kpis.kpi_3.name = "PV-Self Use";
      this.kpi_setting.pv_net_metering_kpis.kpi_4.name = "Export To Gird";
      this.kpi_setting.pv_net_metering_kpis.kpi_5.name = "Import From Gird";
      this.kpi_setting.pv_net_metering_kpis.kpi_6.name = "Genset";
    }

    if (type == 'chart') {

      // status 
      // dashboard 
      this.chart_setting.dashboard.single.graph.chart_1.status = true;
      this.chart_setting.dashboard.single.graph.chart_2.status = true;
      this.chart_setting.dashboard.single.graph.chart_3.status = true;
      this.chart_setting.dashboard.single.graph.chart_4.status = true;

      // pv_string_monitoring 
      this.chart_setting.pv_string_monitoring.graph.chart_1.status = true;
      this.chart_setting.pv_string_monitoring.graph.chart_2.status = true;
      this.chart_setting.pv_string_monitoring.graph.chart_3.status = true;
      this.chart_setting.pv_string_monitoring.graph.chart_4.status = true;

      // pv_net_metering
      this.chart_setting.pv_net_metering.graph.chart_1.status = true;
      this.chart_setting.pv_net_metering.graph.chart_2.status = true;
      this.chart_setting.pv_net_metering.graph.chart_3.status = true;
      this.chart_setting.pv_net_metering.graph.chart_4.status = true;
       
      // header 
      // dashboard 
      this.chart_setting.dashboard.single.graph.chart_1.header = "AVG. LINE VOLTAGE VL-L (VOLTS)";
      this.chart_setting.dashboard.single.graph.chart_2.header = "AVG. 3 PHASE CURRENT (AMPS)";
      this.chart_setting.dashboard.single.graph.chart_3.header = "TOTAL ACTIVE POWER (KW)";
      this.chart_setting.dashboard.single.graph.chart_4.header = "POWER FACTOR 3 PHASE (AVG)";

      // pv_string_monitoring 
      this.chart_setting.pv_string_monitoring.graph.chart_1.header = "Power";
      this.chart_setting.pv_string_monitoring.graph.chart_2.header = "Current";
      this.chart_setting.pv_string_monitoring.graph.chart_3.header = "Energy";
      this.chart_setting.pv_string_monitoring.graph.chart_4.header = "Voltage";

      // pv_net_metering
      this.chart_setting.pv_net_metering.graph.chart_1.header = "Power Trend";
      this.chart_setting.pv_net_metering.graph.chart_2.header = "Current State";
      this.chart_setting.pv_net_metering.graph.chart_3.header = "Pv-Yeild Energy";
      this.chart_setting.pv_net_metering.graph.chart_4.header = "Weather";
    
    }

    if (type == 'cost') {

      this.cost_by_month_value.per_kwh_unit_rate = 40;
      this.cost_by_month_value.selling_rate = 22;

    }
  }

  getCities() {

    this.location.cities.dropdownList = [];

    let keys = Object.keys(this.dataShared.cities_list);
    let values = Object.values(this.dataShared.cities_list);

    for (let i = 0; i < keys.length; i++) {
      this.location.cities.dropdownList.push({
        key: keys[i],
        value: values[i],
        isDisabled: (this.mv_opt.location.disabled == 'true') ? true : false
      })
    }

    this.location.cities.dropdownList.sort((a, b) => a.key.localeCompare(b.key));

    this.locationDropdownSettings = {
      singleSelection: true,
      idField: 'key',
      textField: 'value',
      showSelectedItemsAtTop: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      clearSearchFilter: true,
      searchPlaceholderText: 'Select city'
    };
  }

  getStates() {

    let keys = Object.keys(this.dataShared.states_list);
    let values = Object.values(this.dataShared.states_list);

    for (let i = 0; i < keys.length; i++) {

      this.location.states.push({
        key: keys[i],
        value: values[i]
      })
    }

    this.location.states.sort((a, b) => a.key.localeCompare(b.key));

  }

  getBody() {

    let body = {
      action: this.action
    }

    if (this.action == 'insertSettings') {
      body['status'] = this.setting.status;
      body['account_id'] = this.setting.account;
      body['meta_key'] = this.setting.meta_key;
      body['meta_value'] = JSON.stringify(this.meta_value);
      body['dashboard_setting'] = JSON.stringify(this.dashboard_setting);
      body['tab_setting'] = JSON.stringify(this.tab_setting);
      body['kpi_setting'] = JSON.stringify(this.kpi_setting);
      body['chart_setting'] = JSON.stringify(this.chart_setting);
      body['cost_by_month'] = JSON.stringify(this.cost_by_month);
      body['solar_performance_parameters'] = (this.solar_performance_parameters_status) ? JSON.stringify(this.solar_performance_parameters) : "";
    }

    if (this.action == 'getDevices') {
      body['account_id'] = this.setting.account;
    }

    return body;
  }

  onChangeButton(type, e) {

    if (type == 'status') this.setting.status = e;
    else if (type == 'alow_disk_space') {

      this.mv_opt.allow_disk_space.checkbox = e.target.checked;
      this.mv_opt.allow_disk_space.disabled = (e.target.checked) ? 'false' : 'true';

    } else if (type == 'peak') {

      this.mv_opt.peak.checkbox = e.target.checked;
      this.mv_opt.peak.disabled = (e.target.checked) ? 'false' : 'true';

    } else if (type == 'location') {

      this.mv_opt.location.checkbox = e.target.checked;
      this.mv_opt.location.disabled = (e.target.checked) ? 'false' : 'true';

      this.getCities();
    } else if (type == 'nm' || type == 'ke' || type == 'pv' || type == 'gs') {

      if (type == 'nm') this.mv_opt.nm.checkbox = e.target.checked;
      if (type == 'ke') this.mv_opt.nm.ke.checkbox = e.target.checked;
      if (type == 'pv') this.mv_opt.nm.pv.checkbox = e.target.checked;
      if (type == 'gs') this.mv_opt.nm.gs.checkbox = e.target.checked;

      this.mv_opt.nm.display = (this.mv_opt.nm.checkbox) ? 'd-block' : 'd-none';
      this.mv_opt.nm.ke.disabled = (this.mv_opt.nm.checkbox && this.mv_opt.nm.ke.checkbox) ? 'false' : 'true';
      this.mv_opt.nm.pv.disabled = (this.mv_opt.nm.checkbox && this.mv_opt.nm.pv.checkbox) ? 'false' : 'true';
      this.mv_opt.nm.gs.disabled = (this.mv_opt.nm.checkbox && this.mv_opt.nm.gs.checkbox) ? 'false' : 'true';

      this.getDevices();
    } else if (type == 'btn_pass') {

      this.mv_opt.btn_password.checkbox = e.target.checked;
      this.mv_opt.btn_password.disabled = (e.target.checked) ? 'false' : 'true';

    } else if (type == 'level_unit') {

      this.mv_opt.level_unit.checkbox = e.target.checked;
      this.mv_opt.level_unit.disabled = (e.target.checked) ? 'false' : 'true';

    } else if (type == 'flow_unit') {

      this.mv_opt.flow_unit.checkbox = e.target.checked;
      this.mv_opt.flow_unit.disabled = (e.target.checked) ? 'false' : 'true';

    } else if (type == 'flow_rate') {

      this.mv_opt.flow_rate.checkbox = e.target.checked;
      this.mv_opt.flow_rate.disabled = (e.target.checked) ? 'false' : 'true';

    } else if (type == 'solar_performance_parameters') {

      this.solar_performance_parameters = {
        installed_capicity: 0,
        predicted_generation: 0,
        inverter_make: "",
        panel_make: "",
        location: "",
        solar_insolation: 0,
        average_sun_perday: 0,
        carbon_factor: 0
      }

    }
  }

  getAccounts() {
    this.action = 'getAccounts'; this.accounts = [];
    this.dashboardService.httpPost(this.getBody()).subscribe((res: any) => {

      res.data.forEach(e => {
        this.accounts.push({
          id: e.id,
          name: e.name
        })
      });
    })
  }

  getDevices() {
    this.action = 'getDevices';
    this.dashboardService.httpPost(this.getBody()).subscribe((res: any) => {
      this.nmDropdownSetting(res.data);
    })
  }

  nmDropdownSetting(data) {
    let ke = []; let pv = []; let gs = [];

    data.forEach(e => {
      ke.push({
        ['location' + e.account]: e.location + "    (" + e.device_id + ")",
        ['device_id' + e.account]: e.device_id,
        isDisabled: (this.mv_opt.nm.ke.disabled == 'true') ? true : false
      })

      pv.push({
        ['location' + e.account]: e.location + "    (" + e.device_id + ")",
        ['device_id' + e.account]: e.device_id,
        isDisabled: (this.mv_opt.nm.pv.disabled == 'true') ? true : false
      })

      gs.push({
        ['location' + e.account]: e.location + "    (" + e.device_id + ")",
        ['device_id' + e.account]: e.device_id,
        isDisabled: (this.mv_opt.nm.gs.disabled == 'true') ? true : false
      })

    });

    this.mv_opt.nm.ke.dropdownList = ke; this.mv_opt.nm.pv.dropdownList = pv; this.mv_opt.nm.gs.dropdownList = gs;

    this.nmDropdownSettings = {
      singleSelection: false,
      idField: 'device_id' + data[0].account,
      textField: 'location' + data[0].account,
      itemsShowLimit: 1,
      allowSearchFilter: false
    };
  }

  metaValueJson() {

    this.meta_value = { allow_disk_space: '', peak: { start: '', end: '' }, location: { city: '', state: '', country: '' }, nm: { ke: [], pv: [], gs: [] }, btn_password: '', level_unit: '', flow_unit: '', flow_rate: '' };


    // meta value
    (this.mv_opt.allow_disk_space.checkbox) ? this.meta_value.allow_disk_space = this.mv_opt.allow_disk_space.value : delete this.meta_value.allow_disk_space;
    (this.mv_opt.btn_password.checkbox) ? this.meta_value.btn_password = this.mv_opt.btn_password.value : delete this.meta_value.btn_password;
    (this.mv_opt.level_unit.checkbox) ? this.meta_value.level_unit = this.mv_opt.level_unit.value : delete this.meta_value.level_unit;
    (this.mv_opt.flow_unit.checkbox) ? this.meta_value.flow_unit = this.mv_opt.flow_unit.value : delete this.meta_value.flow_unit;
    (this.mv_opt.flow_rate.checkbox) ? this.meta_value.flow_rate = this.mv_opt.flow_rate.value : delete this.meta_value.flow_rate;

    // peak 
    if (this.mv_opt.peak.checkbox) { this.meta_value.peak.start = this.mv_opt.peak.start; this.meta_value.peak.end = this.mv_opt.peak.end; }
    else { delete this.meta_value.peak; }

    // location 
    if (this.location.cities.selectedItems.length > 0) { this.mv_opt.location.city = this.location.cities.selectedItems[0].key }
    if (this.mv_opt.location.checkbox) { this.meta_value.location.city = this.mv_opt.location.city; this.meta_value.location.state = this.mv_opt.location.state; this.meta_value.location.country = this.mv_opt.location.country; }
    else delete this.meta_value.location;

    // nm 
    if (this.mv_opt.nm.checkbox) {

      // ke 
      if (this.mv_opt.nm.ke.checkbox) {
        this.mv_opt.nm.ke.value.forEach(e => {
          this.meta_value.nm.ke.push(e['device_id' + this.setting.account])
        });
      } else delete this.meta_value.nm.ke;

      // pv 
      if (this.mv_opt.nm.pv.checkbox) {
        this.mv_opt.nm.pv.value.forEach(e => {
          this.meta_value.nm.pv.push(e['device_id' + this.setting.account])
        });
      } else delete this.meta_value.nm.pv;

      // gs 
      if (this.mv_opt.nm.gs.checkbox) {
        this.mv_opt.nm.gs.value.forEach(e => {
          this.meta_value.nm.gs.push(e['device_id' + this.setting.account])
        });
      } else delete this.meta_value.nm.pv;

    } else delete this.meta_value.nm;

  }

  costByMonthJson() {

    let value = Object.values(this.cost_by_month)

    for (let i = 0; i < value.length; i++) {
      for (let j = 0; j < Object.values(value[i]).length; j++) {

        Object.values(value[i])[j]['per_kwh_unit_rate(rs)'] = this.cost_by_month_value.per_kwh_unit_rate
        Object.values(value[i])[j]['selling_rate(rs)'] = this.cost_by_month_value.selling_rate
        Object.values(value[i])[j]['service_charges'] = this.cost_by_month_value.service_charges
        Object.values(value[i])[j]['misc_charges'] = this.cost_by_month_value.misc_charges
        Object.values(value[i])[j]['late_charges'] = this.cost_by_month_value.late_charges
        Object.values(value[i])[j]['genset_unit_rate_rs'] = this.cost_by_month_value.genset_unit_rate_rs

      }
    }
  }

  createSetting() {

    // this.action = 'insertSettings';
    // this.metaValueJson(); this.costByMonthJson();
    // this.dashboardService.httpPost(this.getBody()).subscribe((res: any) => {
    //   this.toastr.info(res.data.message);
    // })
  }
}